import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import styles from './navigation.module.scss';
import ClearServices from '../../Assets/Images/Logos/ClearServices Logos/ClearServices.png';
import MenuButton from '../MenuButton/MenuButton';

const Navigation = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const [displayBackdrop, setDisplayBackdrop] = useState(false);
    const rawRole = localStorage.getItem('role');
    const role = rawRole ? rawRole.toLowerCase() : '';
    const userRoleLevel = Number(localStorage.getItem('roleLevel'));
    const isPrivate = props.isPrivate;

    const handleBackdrop = () => {
        setDisplayBackdrop(!displayBackdrop);
        const body = document.body;
        if (displayBackdrop) {
            body.style.overflow = 'auto';
        } else {
            body.style.overflow = 'hidden';
        }
    };

    let menuRender = props.menuItems.map((m, index) => {
        const canRender = !isPrivate || (isPrivate && m.roles.includes(userRoleLevel));

        const effectiveUrl = isPrivate && m.url !== '/' ? `/${role}${m.url}` : m.url;

        const isActive =
            location.pathname === effectiveUrl ||
            (effectiveUrl !== '/' && location.pathname.startsWith(effectiveUrl + '/'));

        return (
            canRender && (
                <h4
                    key={index}
                    className={isActive ? styles.activeMenuItem : ''}
                    onClick={() => {
                        if (m.name === 'Log Out') {
                            localStorage.clear(); // or selectively remove token, role etc.
                        }
                        navigate(effectiveUrl);
                        handleBackdrop();
                    }}
                >
                    {m.name}
                </h4>
            )
        );
    });

    return (
        <>
            {displayBackdrop ? (
                <div
                    className={`${styles.backDrop} ${displayBackdrop ? styles.backDropOpen : ''}`}
                    onClick={handleBackdrop}
                />
            ) : null}

            <div
                className={`${styles.sideBar} ${displayBackdrop ? styles.sideBarOpen : styles.sideBarClosed}`}
            >
                <div className={styles.sideBarMiddle}>{menuRender}</div>
            </div>

            <div className={styles.navigationBar}>
                <a href='/'>
                    <img src={ClearServices} alt='ClearServices' />
                </a>
                {isPrivate ? <h5>{new Date().toDateString()}</h5> : null}
                <MenuButton isOpen={displayBackdrop} toggle={handleBackdrop} />
            </div>
        </>
    );
};

export default Navigation;
